import { render, staticRenderFns } from "./consultationListNew.vue?vue&type=template&id=78ad79d6&scoped=true"
import script from "./consultationListNew.vue?vue&type=script&lang=js"
export * from "./consultationListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad79d6",
  null
  
)

export default component.exports